const state = {
    suspectedCaseReportAddInfo: {},
  }
  
  const mutations = {
    SET_S_ADDINFO: (state, suspectedCaseReportAddInfo) => {
      state.suspectedCaseReportAddInfo = suspectedCaseReportAddInfo
      sessionStorage.setItem('suspectedCaseReportAddInfo', JSON.stringify(suspectedCaseReportAddInfo))
    },
  }
  
  const actions = {
   
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  